import React, { useState } from 'react';

import { Badge, Tooltip } from 'antd';

import { useIntl } from 'react-intl';

const style = {
  width: 10,
  height: 10,
  minWidth: 10,
  maxWidth: 10,
  cursor: 'pointer',
};

const Mark = (props) => {
  const { children, show, left = false } = props;

  const [visible, setVisible] = useState(false);

  const intl = useIntl();

  return (
    <Tooltip
      trigger={['hover']}
      visible={show && visible}
      title={intl.formatMessage({
        id: 'Check out a new feature',
        defaultMessage: 'Check out a new feature',
      })}
      placement={left ? 'left' : 'top'}
    >
      <Badge
        dot={show}
        style={style}
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
      >
        {children}
      </Badge>
    </Tooltip>
  );
};

export default Mark;
